import { render, staticRenderFns } from "./sub-bubble-agreements-editor-dialog.vue?vue&type=template&id=44fa8d36"
import script from "./sub-bubble-agreements-editor-dialog.vue?vue&type=script&lang=js"
export * from "./sub-bubble-agreements-editor-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports